import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

/**
 * Слайдер текстового блока Лицензий.
 */
export default function sliderNotTabPromo() {
  // eslint-disable-next-line no-new
  new Swiper('.slider-not-tab-promo .swiper', {
    direction: 'horizontal',
    rewind: true,
    spaceBetween: 20,
    slidesPerView: 2,
    draggable: true,
    centeredSlides: false,
    preloadImages: false,
    centeredSlidesBounds: false,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    scrollbar: {
      el: '.slider-not-tab-promo .swiper-scrollbar',
      hide: false,
      draggable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: '.slider-not-tab-promo .swiper-button-next',
      prevEl: '.slider-not-tab-promo .swiper-button-prev',
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
    },
  });
}
